import { SOCIAL_MEDIA_TYPES } from "~/constants/social";

// Base media types (non-social)
const baseMediaTypes = [
  {
    name: "sharedComponents.media.web",
    value: "web",
    icon: ["far", "globe"],
  },
  {
    name: "sharedComponents.media.print",
    value: "print",
    icon: ["far", "newspaper"],
  },
  {
    name: "sharedComponents.media.tv",
    value: "tv",
    icon: ["far", "tv-retro"],
  },
  {
    name: "sharedComponents.media.radio",
    value: "radio",
    icon: ["far", "radio"],
  },
  {
    name: "sharedComponents.media.podcast",
    value: "podcast",
    icon: ["fas", "podcast"],
  },
  {
    name: "sharedComponents.media.social",
    value: "social",
    icon: ["far", "share-nodes"],
  },
];

// Social media type icons mapping
const socialMediaIcons = {
  facebook: ["fab", "facebook"],
  instagram: ["fab", "instagram"],
  twitter: ["fab", "x-twitter"],
  youtube: ["fab", "youtube"],
} as const;

// Generate social media types dynamically
const socialMediaTypes = SOCIAL_MEDIA_TYPES.map((type) => ({
  name: `sharedComponents.media.${type}`,
  value: type,
  icon: socialMediaIcons[type],
}));

// Combine all media types
const mediaTypes = [...baseMediaTypes, ...socialMediaTypes];

// Generate icon map from mediaTypes array (single source of truth)
const MEDIA_TYPE_ICON_MAP: Record<string, string[]> = {
  ...Object.fromEntries(mediaTypes.map(({ value, icon }) => [value, icon])),
  digital: ["far", "globe"], // Alias for web - needed for legacy compatibility
};

const MEDIA_TYPE_COLOR_MAP: Record<string, string> = {
  web: "blue",
  digital: "blue",
  print: "lime",
  tv: "purple",
  radio: "pink",
  social: "yellow",
  facebook: "blue",
  instagram: "pink",
  twitter: "purple",
  youtube: "rose",
  podcast: "blue",
};

const SOCIAL_MEDIA_TYPE_COLOR_MAP: Record<string, string> = {
  facebook: "#0866FF", // Facebook Blue
  twitter: "#000000", // Twitter Black
  instagram: "#E1306C", // Instagram Pink
  youtube: "#FF0000", // YouTube Red
};

const AI_SUMMARY_UNLOCK_MEDIA_CATEGORY_ICONS = {
  digital: ["far", "globe"],
  print: ["far", "newspaper"],
  broadcast: ["fas", "signal-stream"],
  podcast: ["fas", "podcast"],
  social: ["far", "share-nodes"],
};

export default mediaTypes;

export {
  MEDIA_TYPE_ICON_MAP,
  MEDIA_TYPE_COLOR_MAP,
  SOCIAL_MEDIA_TYPE_COLOR_MAP,
  AI_SUMMARY_UNLOCK_MEDIA_CATEGORY_ICONS,
};
